import { Localization } from 'connex-cds';
import { StatusChip } from './styles';

const { useShortDateTime: shortDateTime } = Localization || {};

export const getShortDateTime = (date, timeZone = null) => {
  if (!date) return null;
  const { getShortDateTime } = shortDateTime({ overrideTimeZone: timeZone });
  return getShortDateTime(date);
};

export const useTableColumns = tableRefValue => {
  const width = tableRefValue?.offsetWidth ?? 1805;
  const translateMessage = Localization.useTranslateMessage();
  return [
    {
      field: 'createDate',
      headerAlign: 'center',
      align: 'center',
      renderCell: params => getShortDateTime(new Date(params?.value), params?.row?.origin?.timeZone),
      headerName: translateMessage('gridHeader_created'),
      minWidth: 250,
      width: width / 5,
      hideable: false,
      editable: false,
    },
    {
      field: 'ticketId',
      headerAlign: 'center',
      align: 'center',
      headerName: translateMessage('gridHeader_ticketId'),
      width: width / 5,
      hideable: false,
      editable: false,
    },
    {
      field: 'customerStatus',
      headerAlign: 'center',
      align: 'center',
      headerName: translateMessage('gridHeader_customerStatus'),
      width: width / 5,
      hideable: false,
      editable: false,
    },
    {
      field: 'vehicleId',
      headerAlign: 'center',
      align: 'center',
      headerName: translateMessage('gridHeader_vehicle'),
      width: width / 5,
      hideable: false,
      editable: false,
    },
    {
      field: 'isVoided',
      headerAlign: 'center',
      align: 'center',
      headerName: translateMessage('ticketStatus'),
      width: width / 5,
      hideable: false,
      editable: false,
      renderCell: params => (
        <StatusChip
          voided={params?.value}
          label={params?.value ? translateMessage('voided') : translateMessage('ticketed')}
          size="small"
        />
      ),
    },
  ];
};
